import { render, staticRenderFns } from "./AppModal.vue?vue&type=template&id=48a64528&scoped=true&lang=pug&"
import script from "./AppModal.vue?vue&type=script&lang=js&"
export * from "./AppModal.vue?vue&type=script&lang=js&"
import style0 from "./AppModal.vue?vue&type=style&index=0&id=48a64528&scoped=true&lang=scss&"
import style1 from "./AppModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a64528",
  null
  
)

export default component.exports